import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import SEOHead from "../components/shared/SEOHead";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Terms & Conditions | Hitech Transit"
        description="Terms and conditions for Hitech Transit removal services. Read our service agreement, cancellation policy, and liability terms."
        canonical="/terms"
      />
      <Header />
      
      <main className="pt-20">
        <section className="bg-[#0F172A] py-16">
          <div className="container-max px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-['Outfit'] font-bold text-white">Terms & Conditions</h1>
          </div>
        </section>

        <section className="section-padding">
          <div className="container-max">
            <div className="max-w-3xl mx-auto prose prose-slate">
              <p className="text-sm text-slate-500 mb-8">Last updated: January 2026</p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">1. Introduction</h2>
              <p className="text-slate-600 mb-4">
                These Terms and Conditions govern your use of Hitech Transit's removal services. By booking with us, 
                you agree to be bound by these terms.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">2. Quotations</h2>
              <p className="text-slate-600 mb-4">
                Online quotes are estimates based on information provided. Final prices may vary depending on actual 
                circumstances discovered on moving day. For accurate pricing, we recommend a free survey.
              </p>
              <p className="text-slate-600 mb-4">
                Quotes are valid for 30 days from the date issued. Prices may be subject to change for moves 
                booked more than 30 days after the quote date.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">3. Booking & Deposit</h2>
              <p className="text-slate-600 mb-4">
                A 25% deposit is required to secure your booking. The remaining balance is due on the day of the move 
                before unloading begins. We accept card payments and PayPal.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">4. Cancellation Policy</h2>
              <p className="text-slate-600 mb-4">
                <strong>More than 7 days notice:</strong> Full refund of deposit.<br />
                <strong>3-7 days notice:</strong> 50% of deposit refunded.<br />
                <strong>Less than 3 days notice:</strong> No refund of deposit.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">5. Your Responsibilities</h2>
              <p className="text-slate-600 mb-4">
                You must ensure that all items to be moved are properly prepared and that there is adequate access 
                at both collection and delivery addresses. You should inform us of any parking restrictions, 
                narrow access, or other potential difficulties.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">6. Insurance & Liability</h2>
              <p className="text-slate-600 mb-4">
                All moves are covered by our Goods in Transit insurance up to £50,000. Claims must be made in writing 
                within 7 days of the move. We are not liable for items packed by the customer.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">7. Prohibited Items</h2>
              <p className="text-slate-600 mb-4">
                We cannot transport hazardous materials, illegal items, perishable goods, or live animals. 
                Please inform us of any items that may require special handling.
              </p>

              <h2 className="text-xl font-['Outfit'] font-bold text-[#0F172A] mt-8 mb-4">8. Contact</h2>
              <p className="text-slate-600 mb-4">
                For any questions about these terms, please contact us at hello@hitechtransit.com or call 07346 209593.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
